import { getStore } from '../../helpers/initStore.js';

const applyFeatureFlagOverrides = (featureFlags, featureFlagOverrides) => ({ ...featureFlags, ...featureFlagOverrides });
const getIsDebugMode = () => !!getStore().state.variables.featureFlags.debug;

export { applyFeatureFlagOverrides, getIsDebugMode };
